import Dashboard from './Dashboard'
import connect from './connect'

export default connect(Dashboard)
